// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
//import { jarallax, jarallaxVideo } from 'jarallax';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { offcanvas } from "./modules/_offcanvas.mjs";
import { reviewSlider } from "./modules/_carousels.mjs";
import { introSlider } from "./modules/_carousels.mjs";

document.addEventListener("DOMContentLoaded", function () {
    //jarallax(document.querySelectorAll('.jarallax'), { speed: 0.5 });
    //jarallaxVideo();
    validate();
    offcanvas();
    introSlider();
    reviewSlider();

    const disclosure = new Disclosure();
});
